
import React, { FC, useEffect, useRef } from "react"
import { useGoogleMaps, googleMapsAuthFailed } from "../../../hooks/useGoogleMaps"

interface Props {
	latitude: number;
	longitude: number;
	googleMapURL: string;
	loadingElement: React.ReactElement;
	containerElement: React.ReactElement;
	mapElement: React.ReactElement;
}

// One marker at the answer's location; talks to the Google Maps JS API directly
const Map: FC<Props> = ({ latitude: lat, longitude: lng, googleMapURL, loadingElement, containerElement, mapElement }) => {

	const maps = useGoogleMaps(googleMapURL)
	const mapDiv = useRef<HTMLDivElement>(null)

	useEffect(() => {
		// Google observes the element straight away, so it has to be a real element in the document
		// and after a key rejection Google's own constructor throws, so leave the map empty then
		if (!maps || googleMapsAuthFailed() || !(mapDiv.current instanceof HTMLElement) || !mapDiv.current.isConnected) {
			return
		}

		const map = new maps.Map(mapDiv.current, { center: { lat, lng }, zoom: 16 })
		const marker = new maps.Marker({ map, position: { lat, lng } })

		return () => marker.setMap(null)
	}, [ maps, lat, lng ])

	if (!maps) {
		return loadingElement
	}

	return React.cloneElement(containerElement, {}, React.cloneElement(mapElement, { ref: mapDiv }))
};

export default Map;
